import AssignSerialNumberDialog from "./assignSerialNumberDialog.container";

export default AssignSerialNumberDialog;
